import { Injectable } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

//import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
////import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const expectedRoles = route.data.expectedRoles;
    const remD = JSON.parse(localStorage.getItem('optplanner_user'));
    if(remD.userType == undefined){
      this.router.navigate(['/login']);
    }
    const userRole = remD.userType.type;
    if (!expectedRoles.includes(userRole)) {
      this.router.navigate(['dashboard']);
      return false;
    }
    return true;
  }
}